import { render, staticRenderFns } from "./NewAuthorization.vue?vue&type=template&id=9b21acbc&scoped=true"
import script from "./NewAuthorization.vue?vue&type=script&lang=js"
export * from "./NewAuthorization.vue?vue&type=script&lang=js"
import style0 from "./NewAuthorization.vue?vue&type=style&index=0&id=9b21acbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b21acbc",
  null
  
)

export default component.exports